import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapPastEventsResponse } from "src/utils/mapPastEvents";

/**
 * Fetches all past events from pg-payload-cms, newest year first
 * (stable `_order` within each year, matching the static JSON key order).
 *
 * Single-fetch design: the winners detail page resolves its event client-side
 * from this same list by slug (see usePastEvent) — no second endpoint contract.
 *
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<import('src/utils/mapPastEvents').PastEvent[]>}
 */
export async function fetchPastEvents(locale) {
  const url = buildPayloadApiUrl("/api/past-events", {
    locale,
    limit: 1000,
    sort: "-year,_order",
  });

  const response = await payloadFetch(url);
  return mapPastEventsResponse(response, locale);
}
